<template>
    <div class="p2">
        <CRow>
            <CCol col=12 style="border-bottom: 1px solid black; padding-bottom:1rem;">
                <CForm inline>
                    <div class="col-lg-3 col-md-6 col-sm-12 form-inline">
                        <label class="col-form-label mr-2">
                            농가 정보 :
                        </label>
                        <div role="group" class="form-group form-row">
                            <CSelect :value.sync="app.facilityId" ref="facility" :options="app.facilityList"
                                style="margin-bottom: 0;">
                            </CSelect>
                            <CSelect :value.sync="inFacilityId" ref="infacility" :options="inFacilityList"
                                style="margin-bottom: 0;">
                            </CSelect>
                        </div>
                    </div>
                    <div class="col-lg-9 col-md-6 col-sm-12 form-inline">
                        <CRow>
                            <CCol col=4>
                                <label class="col-form-label mr-2" style="min-width: 55px; display: block">검색조건 :
                                </label>
                            </CCol>
                            <CCol col=6>
                                <CInputRadioGroup inline :checked.sync="Search_Type"
                                    :options="[{value:'date_Type',label:'날짜 기준 검색'},{value:'sampleNo_Type',label:'샘플 기준 검색'}]">
                                </CInputRadioGroup>
                            </CCol>
                        </CRow>
                        <CRow v-if="Search_Type == 'date_Type'" >
                            <CCol col=12>
                                <CSelect :value.sync="Search_Date_Type"
                                    :options="['일별','주별']">
                                </CSelect>
                            </CCol>
                        </CRow>
                        <CRow v-if="Search_Type == 'date_Type'" >
                            <CCol col=12>
                                <v-date-picker v-if="Search_Date_Type == '일별'" class="form-inline" v-model="searchAtRange" @input="setChart()" is-range
                                    :max-date="getMaxDate()" :masks="{ title: 'YYYY년 MMM', L: 'YYYY-MM-DD' }">
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <div class="w-100 flex justify-center items-center">
                                            <input :value="inputValue.start" v-on="inputEvents.start" 
                                                class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                                                style="height: 35px; width: 47%" />
                                            ~
                                            <input :value="inputValue.end" v-on="inputEvents.end" 
                                                class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                                                style="height: 35px; width: 47%" disabled/>
                                        </div>
                                    </template>
                                </v-date-picker>
                                <div role="group" v-if="Search_Date_Type == '주별'" class="form-group form-row w-100 ml-2">
                                    <multiselect class="w-100" @close="setChart()" v-model="selectedWeek" :options="Week" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="text" track-by="value">
                                        <template class="w-100" slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                                    </multiselect>
                                </div>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol v-if="Search_Type=='sampleNo_Type'" class="form-inline" col=12>

                                <div role="group" class="form-group form-row col-lg-8 col-md-8 col-sm-6">
                                    
                                    <multiselect v-model="selectedSampleNo" @close="setChart()" :options="SampleNo" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="text" track-by="value">
                                        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
                                    </multiselect>
                                </div>
                                <div role="group" class="form-group form-row col-lg-3 col-md-4 col-sm-6">
                                    <v-date-picker v-model="sampleNo_Date" :max-date="getMaxDate()" @input="setChart()" 
                                        :masks="{ title: 'YYYY년 MMM', L: 'YYYY-MM-DD' }" class="w-100">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <div class="flex justify-center items-center">
                                                <input :value.sync="sampleNo_Date" :value="inputValue"
                                                    v-on="inputEvents"
                                                    class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300" />
                                            </div>
                                        </template>
                                    </v-date-picker>
                                </div>
                                <!--
                                <CInputCheckbox inline v-for="item in sampleNo" :label="item.text" :value="item.value">
                                </CInputCheckbox>
                                -->
                            </CCol>
                        </CRow>

                    </div>
                </CForm>
            </CCol>
        </CRow>

        <CRow class="mt-2">
            <CCol col=12>
                <CForm inline>
                    <label class="col-form-label ml-2 mr-2" style="min-width: 55px; display: block">검색대상</label>
                    <CSelect @change="Select_Change" :options="fields"></CSelect>
                </CForm>
            </CCol>
        </CRow>
        <CRow>
            <CCol col=12>
                <div 
                  :class="chart == null || chart.data.length === 0 ? 'd-none' : ''" ref="Info_chart" style="width: 100%; height: 400px"></div>
                
                <div
                style="
                    width: 100%;
                    height: 400px;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    text-align: center;
                    font-weight: bold;
                    font-size: 150%;
                    color: #ff0d0d;
                "
                v-if="(chart == null || chart.data.length === 0)"
                >
                <div>
                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                    데이터 없음
                </div>
                </div>
            </CCol>
        </CRow>
        <CRow>
            <CCol lg=11 md=10 sm=0></CCol>
            <CCol lg=1 md=2 sm=12 style="float:right">
                <CButton @click="Show_Detail()">자세히보기 <CIcon :name="detail_icon"></CIcon></CButton>
            </CCol>
        </CRow>
        <CRow v-if="this.detail_icon == 'cil-chevron-circle-up-alt'">
            <CCol col="12">
                <CDataTable class="table-bordered" style="overflow-x:scroll;" :items="table_items"
                    :fields="table_fields" items-per-page-select :items-per-page="5" hover sorter pagination>
                </CDataTable>
            </CCol>
        </CRow>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
    import axios from "axios";
    import core from "@/core";
    import Multiselect from 'vue-multiselect'
    import MixinsInFacility from "@/mixins/in-facility";
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    am4core.useTheme(am4themes_animated);

    export default {
        name: "GrowthInformation",
        components: {Multiselect},
        mixins: [MixinsInFacility()],
        data() {
            return {
                detail_icon:"cil-chevron-circle-down-alt",
                isinit:true,
                searchAtRange: null,
                inFacilityId: 0,
                Search_Date_Type: "일별",
                select_options: 
                    {
                        label: '초장(cm)',
                        value: "SG_PLANT_LENGTH"
                    },
                Search_Type: "date_Type",
                chart: null,
                SampleNo: [],
                selectedSampleNo:[],
                Week: [],
                selectedWeek:[],
                sampleNo_Date: core.date.instance().add(-1,"day").toDate(),
                table_fields: [
                    {
                        label: '날짜',
                        _style: 'width:10%', key: "SG_GROWTH_DATE"
                    },
                    {
                        label: '주차',
                        _style: 'width:4%', key: "SG_GROWTH_WEEK"
                    },
                    {
                        label: '샘플 ID',
                        _style: 'width:5%', key: "SG_SAMPLE_NUMBER"
                    },
                    {
                        label: '초장(cm) :',
                        _style: 'width:5%', key: "SG_PLANT_LENGTH"
                    },
                    {
                        label: '옆수 :',
                        _style: 'width:6%', key: "SG_LEAF_COUNT"
                    },
                    {
                        label: '옆장(cm) :',
                        _style: 'width:5%', key: "SG_LEAF_LENGTH"
                    },
                    {
                        label: '옆폭(cm) :',
                        _style: 'width:5%', key: "SG_LEAF_WIDTH"
                    },
                    {
                        label: '절간장(cm) :',
                        _style: 'width:5%', key: "SG_INTERNODE_LENGTH"
                    },
                    {
                        label: '꽃 핀 화방 경경(mm) :',
                        _style: 'width:5%', key: "SG_STEM_DIAMETER"
                    },
                    {
                        label: '꽃 핀 화방 수(번째) :',
                        _style: 'width:8%', key: "SG_FLOWER_CLUSTER"
                    },
                    {
                        label: '꽃 핀 화방 길이(cm) :',
                        _style: 'width:8%', key: "SG_DISTANCE_GROWING_FLOWER"
                    },
                    {
                        label: '마지막 화방 경경(mm) :',
                        _style: 'width:8%', key: "SG_LAST_FLOWER_STEM_DIAMETER"
                    },
                    {
                        label: '마지막 화방 수(번째) :',
                        _style: 'width:8%', key: "SG_LAST_FLOWER_CLUSTER"
                    },
                    {
                        label: '마지막 화방 길이(cm) :',
                        _style: 'width:8%', key: "SG_LAST_FLOWER_LENGTH"
                    },
                    {
                        label: '화방별 꽃수(개/화방) :',
                        _style: 'width:8%', key: "SG_FLOWER_NUMBER"
                    },
                    {
                        label: '생장점과 꽃핀 화방거리(cm) :',
                        _style: 'width:10%', key: "SG_DISTANCE_GROWING_FLOWER"
                    },
                    {
                        label: '화방간 거리(cm) :',
                        _style: 'width:8%', key: "SG_DISTANCE_FLOWER"
                    },
                    {
                        label: '착과수(개/화방) :',
                        _style: 'width:8%', key: "SG_FRUIT_SURVEY"
                    }
                ], 
                table_items: [
                ],
                fields: [
                    {
                        label: '초장(cm)',
                        value: "SG_PLANT_LENGTH"
                    },
                    {
                        label: '옆수',
                        value: "SG_LEAF_COUNT"
                    },
                    {
                        label: '옆장(cm)',
                        value: "SG_LEAF_LENGTH"
                    },
                    {
                        label: '옆폭(cm)',
                        value: "SG_LEAF_WIDTH"
                    },
                    {
                        label: '절간장(cm)',
                        value: "SG_INTERNODE_LENGTH"
                    },
                    {
                        label: '꽃 핀 화방 경경(mm)',
                        value: "SG_STEM_DIAMETER"
                    },
                    {
                        label: '꽃 핀 화방 수(번째)',
                        value: "SG_FLOWER_CLUSTER"
                    },
                    {
                        label: '꽃 핀 화방 길이(cm)',
                        value: "SG_DISTANCE_GROWING_FLOWER"
                    },
                    {
                        label: '마지막 화방 경경(mm)',
                        value: "SG_LAST_FLOWER_STEM_DIAMETER"
                    },
                    {
                        label: '마지막 화방 수(번째)',
                        value: "SG_LAST_FLOWER_CLUSTER"
                    },
                    {
                        label: '마지막 화방 길이(cm)',
                        value: "SG_LAST_FLOWER_LENGTH"
                    },
                    {
                        label: '생장점과 꽃핀 화방거리(cm)',
                        value: "SG_FLOWER_LENGTH"
                    }
                ],
            };
        },
        created(){
            axios.get("/db/Get_Search_Option").then(async (response)=>{
                response.data.Sample.forEach(async (val)=>{
                    this.SampleNo.push({value:val.SG_SAMPLE_NUMBER, text:"Sample "+val.SG_SAMPLE_NUMBER});
                })
                response.data.Week.forEach(async (val)=>{
                    this.Week.push({value:val.SG_GROWTH_WEEK, text:val.SG_GROWTH_WEEK});
                })                
                this.searchAtRange = {start:core.date.instance(response.data.Date[0].min_Date).format('YYYY-MM-DD'), end:core.date.instance(response.data.Date[0].max_Date).format('YYYY-MM-DD')};
            })
        },
        updated() {
            if(this.isinit && this.searchAtRange != null){
                this.setChart();
                this.isinit = false;
            }
        },
        methods: {
            Show_Detail(){
                if(this.detail_icon == "cil-chevron-circle-down-alt"){
                    this.detail_icon = "cil-chevron-circle-up-alt"
                    this.table_items = [];
                    if(this.Search_Type == "date_Type"){
                        if(this.Search_Date_Type == "일별"){
                            var data = {inFacility:this.inFacilityId, startDate:this.searchAtRange.start, endDate:this.searchAtRange.end};
                            axios.post("/db/Get_Detail_date",data).then(async (val)=>{
                                if(val.status == 200 || val.status == 304){
                                    val.data.forEach((value)=>{
                                        this.table_items.push(value);
                                    })
                                }else{
                                    this.table_items = null;
                                }
                            })
                        }
                        else{
                            var data = {inFacility:this.inFacilityId, week:[]};
                            this.selectedWeek.forEach(async (value)=>{
                                data.week.push(value["value"]);
                            })
                            data.avg = false
                            axios.post("/db/Get_Detail_week",data).then(async (val)=>{
                                if(val.status == 200 || val.status == 304){
                                    val.data.forEach((value)=>{
                                        this.table_items.push(value);
                                    })
                                }else{
                                    this.table_items = null;
                                }
                            })
                        }
                    }else{
                        if(this.selectedSampleNo.length != 0){
                            var data = {inFacility:this.inFacilityId, date:core.date.instance(this.sampleNo_Date).format("YYYY-MM-DD"), Sample:[]};
                            this.selectedSampleNo.forEach(async (value)=>{
                                data.Sample.push(value["value"]);
                            })
                            axios.post("/db/Get_Detail_sample",data).then(async (val)=>{
                                if(val.status == 200 || val.status == 304){
                                    val.data.forEach((value)=>{
                                        this.table_items.push(value);
                                    })
                                }else{
                                    this.table_items = null;
                                }
                            })
                        }
                    }
                }else{
                    this.detail_icon = "cil-chevron-circle-down-alt"
                }
            },
            getMaxDate() {
                return core.date.instance().add(1, "days").toDate();
            },
            Select_Change(event) {
                console.log(event)
                var val_index = this.fields.findIndex((val) => { return val.value == event.target.value });
                this.select_options.value = event.target.value;
                this.select_options["label"] = this.fields[val_index]["label"];
                this.setChart()
            },
            async createChart(param,fieldName) {
                this.chart = am4core.create(this.$refs.Info_chart, am4charts.XYChart);
                var xAxis = null;
                if(fieldName == "date"){
                    this.chart.dateFormatter.dateFormat = "yyyy-MM-dd";
                    xAxis = this.chart.xAxes.push(new am4charts.DateAxis());
                    var label = xAxis.renderer.labels.template;
                    label.wrap = true;
                    label.maxWidth = 60;
                    xAxis.dateFormatter = new am4core.DateFormatter();
                    xAxis.dateFormats.setKey("day", "EEE");
                    xAxis.dataFields.category = "date";
                    xAxis.title.text = "Date";
                    xAxis.renderer.grid.template.location = 0;
                    xAxis.renderer.minGridDistance = 20;
                    xAxis.renderer.cellStartLocation = 0.1;
                    xAxis.renderer.cellEndLocation = 0.9;
                }else if(fieldName == "week"){
                    xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                    xAxis.title.text = "Week";
                    xAxis.dataFields.category = "week"
                    xAxis.renderer.grid.template.location = 0;
                    xAxis.renderer.minGridDistance = 20;
                    xAxis.renderer.cellStartLocation = 0.1;
                    xAxis.renderer.cellEndLocation = 0.9;

                }else{
                    xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                    xAxis.title.text = "Sample No";
                    xAxis.dataFields.category = "sample"
                    xAxis.renderer.grid.template.location = 0;
                    xAxis.renderer.minGridDistance = 20;
                    xAxis.renderer.cellStartLocation = 0.1;
                    xAxis.renderer.cellEndLocation = 0.9;

                }
                this.chart.data = param.chartData;
                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.title.text = param.valueLabel;
                if(fieldName == "date"){
                    if(Array.isArray(param.series)){
                        param.series.forEach((val)=>{
                            let series = this.chart.series.push(new am4charts.ColumnSeries());
                            series.dataFields.valueY = val.field;
                            series.dataFields.dateX = "date";
                            series.name = val.name;
                            series.columns.template.tooltipText = "{name}: {dateX} : [bold]{valueY}[/]";
                            series.columns.template.width = am4core.percent(95);
                        })   
                    }
                    else{
                        let series = this.chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueY = param.series.field;
                        series.dataFields.dateX = "date";
                        series.name = param.series.name;
                        series.columns.template.tooltipText = "{name}: {dateX} : [bold]{valueY}[/]";
                        series.columns.template.width = am4core.percent(95);
                    }
                }else if(fieldName == "week"){
                    if(Array.isArray(param.series)){
                        param.series.forEach((val)=>{
                            let series = this.chart.series.push(new am4charts.ColumnSeries());
                            series.dataFields.valueY = val.field;
                            series.dataFields.categoryX = "week";
                            series.name = val.name;
                            series.columns.template.tooltipText = "{categoryX}주차 : {name} : [bold]{valueY}[/]";
                            series.columns.template.width = am4core.percent(95);
                        })   
                    }
                    else{
                        let series = this.chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueY = param.series.field;
                        series.dataFields.categoryX = "week";
                        series.name = param.series.name;
                        series.columns.template.tooltipText = "{categoryX}주차 : {name} : [bold]{valueY}[/]";
                        series.columns.template.width = am4core.percent(95);
                    }
                }else{
                    let series = this.chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.valueY = param.series.field;
                    series.dataFields.categoryX = "sample";
                    series.name = param.series.name;
                    series.columns.template.tooltipText = "샘플번호 {categoryX} : {name} : [bold]{valueY}[/]";
                    series.columns.template.width = am4core.percent(95);
                }
                this.chart.legend = new am4charts.Legend();
            },
            async setChart() {
                if(this.Search_Type == "date_Type"){
                    if(this.Search_Date_Type == "일별"){
                        if(this.searchAtRange != null){
                            if(this.searchAtRange.start != null & this.searchAtRange.end != null){
                                var diffDate = core.date.instance(this.searchAtRange.end).diff(core.date.instance(this.searchAtRange.start),'days');
                                console.log(this.select_options.value);
                                
                                if( (window.innerWidth <= 768 && diffDate > 5) || (window.innerWidth > 768 && diffDate > 10)){
                                    var data={inFacility:this.inFacilityId, startDate:this.searchAtRange.start, endDate:this.searchAtRange.end,column:this.select_options.value, avg:true}
                                    axios.post("/db/Get_Day_Data",data).then(async (val)=>{
                                        if(val.status == 200 || val.status == 304){
                                            this.createChart({ chartData: val.data, valueLabel: this.select_options.label, series: { field: this.select_options.value, name: this.select_options.label}},"date");
                                        }else{
                                            this.chart = null;   
                                        }
                                    })
                                }
                                else{
                                    var data={inFacility:this.inFacilityId, startDate:this.searchAtRange.start, endDate:this.searchAtRange.end, column:this.select_options.value, avg:false}
                                    axios.post("/db/Get_Day_Data",data).then(async (val)=>{
                                        if(val.status == 200 || val.status == 304){
                                            var chart_data = await this.ChartData(val.data,['date',this.select_options.value]);
                                            var series = [];
                                            this.SampleNo.forEach((val)=>{
                                                series.push({field:val.value,name:val.text});
                                            })
                                            this.createChart({ chartData: chart_data, valueLabel: this.select_options.label, series: series},"date");
                                        }else{
                                            this.chart = null;   
                                        }
                                    })
                                }
                            }
                            else{
                                return;
                            }
                        }
                        else{
                            return;
                        }
                    }else{
                        var data = {inFacility:this.inFacilityId, column:this.select_options.value, week:[]};
                        this.selectedWeek.forEach(async (value)=>{
                            data.week.push(value["value"]);
                        })
                        if( (window.innerWidth <= 768 && this.selectedWeek.length > 5) || (window.innerWidth > 768 && this.selectedWeek.length > 10)){
                            data.avg=true
                            axios.post("/db/Get_Week_Data",data).then(async (val)=>{
                                if(val.status == 200 || val.status == 304){
                                    this.createChart({ chartData: val.data, valueLabel: this.select_options.label, series: { field: this.select_options.value, name: this.select_options.label}},"week");
                                }else{
                                    this.chart = null;   
                                }
                            })
                        }
                        else{
                            data.avg = false
                            axios.post("/db/Get_Week_Data",data).then(async (val)=>{
                                if(val.status == 200 || val.status == 304){
                                    var chart_data = await this.ChartData(val.data,["week",this.select_options.value]);
                                    var series = [];
                                    this.SampleNo.forEach((val)=>{
                                        series.push({field:val.value,name:val.text});
                                    })
                                    this.createChart({ chartData: chart_data, valueLabel: this.select_options.label, series: series},"week");
                                }else{
                                    this.chart = null;   
                                }
                            })
                        }
                    }
                }else{
                    if(this.selectedSampleNo.length != 0){
                        var data = {inFacility:this.inFacilityId, date:core.date.instance(this.sampleNo_Date).format("YYYY-MM-DD"), column:this.select_options.value, Sample:[]};
                        this.selectedSampleNo.forEach(async (value)=>{
                            data.Sample.push(value["value"]);
                        })
                        axios.post("/db/Get_Sample_Data",data).then(async (val)=>{
                            if (this.select_options.value == null) {
                                this.createChart({ chartData: val.data, valueLabel: this.fields[0].label, series: { field: this.fields[0].value, name: this.fields[0].label}},"sample");
                            } else {
                                this.createChart({ chartData: val.data, valueLabel: this.select_options.label, series: { field: this.select_options.value, name: this.select_options.label}},"sample");
                            }
                        })
                    }
                }
            },
            async ChartData(val,column){
                console.log(column);
                var data = [];
                val.forEach(async(value)=>{
                    var temp = {};
                    temp[column[0]] = value[column[0]];
                    temp[value.sample_no] = value[column[1]];
                    data.push(temp)
                })
                console.log(data)
                return data;
            },
        },
    };
</script>